import {userObject, rootStore} from '@/store/types'
import {Module} from 'vuex'
import {mutations} from './mutations'
import {getters} from './getters'

const state: userObject = {
    name: 'first',
    surname: 'second',
    address: 'third',
    authenticated: true,
    token: '',
    appointments: [],
    relatives: [
        {
            name: 'first',
            surname: 'second',
            address: 'something',
            appointments: []
        }
    ]
};

export const userState: Module<userObject, rootStore> = {
    state,
    mutations,
    getters,
    namespaced: true
};